import { ISite, SiteActiveActive, SUBSCRIPTION_HEADER_BIDDER } from '~/src/dash/api/console-api';

export function filterSiteByPrebid(sites: ISite[]): ISite[] {
  return (sites || []).filter((site: ISite) => {
    return site.SubscriptionType === SUBSCRIPTION_HEADER_BIDDER;
  });
}

interface IWithActive {
  Active: string | number;
}

export function filterSitesByActive<Type extends IWithActive>(sites: Type[]): Type[] {
  return sites.filter((site: Type) => {
    if (typeof site.Active === 'string') {
      return site.Active === SiteActiveActive;
    } else {
      return site.Active === 2;
    }
  });
}
